var map = {
	"./abyssal_sire.png": 6744,
	"./alchemical_hydra.png": 4732,
	"./artio.png": 4452,
	"./barrows_chests.png": 5220,
	"./bryophyta.png": 7812,
	"./callisto.png": 5816,
	"./calvarion.png": 667,
	"./cerberus.png": 6576,
	"./chambers_of_xeric.png": 8068,
	"./chambers_of_xeric_challenge_mode.png": 1884,
	"./chaos_elemental.png": 5092,
	"./chaos_fanatic.png": 6200,
	"./commander_zilyana.png": 2832,
	"./corporeal_beast.png": 736,
	"./crazy_archaeologist.png": 7100,
	"./dagannoth_prime.png": 5264,
	"./dagannoth_rex.png": 460,
	"./dagannoth_supreme.png": 4660,
	"./deranged_archaeologist.png": 8828,
	"./duke_sucellus.png": 6756,
	"./general_graardor.png": 5540,
	"./giant_mole.png": 1104,
	"./grotesque_guardians.png": 9464,
	"./hespori.png": 6248,
	"./kalphite_queen.png": 7320,
	"./king_black_dragon.png": 3364,
	"./kraken.png": 7208,
	"./kreearra.png": 3880,
	"./kril_tsutsaroth.png": 8704,
	"./mimic.png": 4868,
	"./nex.png": 6559,
	"./nightmare.png": 8820,
	"./obor.png": 4620,
	"./phantom_muspah.png": 4808,
	"./phosanis_nightmare.png": 1628,
	"./sarachnis.png": 7224,
	"./scorpia.png": 8468,
	"./scurrius.png": 2912,
	"./skotizo.png": 824,
	"./spindel.png": 6872,
	"./tempoross.png": 7080,
	"./the_corrupted_gauntlet.png": 4256,
	"./the_gauntlet.png": 8752,
	"./the_leviathan.png": 3920,
	"./the_whisperer.png": 5972,
	"./theatre_of_blood.png": 3232,
	"./theatre_of_blood_hard_mode.png": 984,
	"./thermonuclear_smoke_devil.png": 3080,
	"./tombs_of_amascut.png": 4140,
	"./tombs_of_amascut_expert.png": 1109,
	"./tzkal_zuk.png": 4304,
	"./tztok_jad.png": 9208,
	"./vardorvis.png": 2544,
	"./venenatis.png": 1919,
	"./vetion.png": 3533,
	"./vorkath.png": 2315,
	"./wintertodt.png": 4292,
	"./zalcano.png": 6989,
	"./zulrah.png": 648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3528;